import { render, staticRenderFns } from "./FcstopElement.vue?vue&type=template&id=fa975288&scoped=true&"
import script from "./FcstopElement.vue?vue&type=script&lang=js&"
export * from "./FcstopElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa975288",
  null
  
)

export default component.exports